import { useState } from 'react'
import { getAccessTokenRefreshedIfPossible } from './useAuth/zustand'
import { toast } from './useToast'

/**
 * Get headers to access degree
 * If not authorized, send x-security-code as degree security code
 */
async function getXSecurityCodeOrAuthorizationHeaders(
  securityCode: string | undefined,
) {
  const headers:
    | {
        'x-security-code': string
      }
    | {
        authorization: string
      }
    | undefined = await (async () => {
    if (securityCode) {
      return {
        'x-security-code': securityCode,
      }
    }

    const authorizationToken = await getAccessTokenRefreshedIfPossible()

    if (!authorizationToken) {
      toast({ title: 'Falha na autenticação' })
      return undefined
    }

    return { authorization: `bearer ${authorizationToken}` }
  })()

  return headers
}

type GenericDocumentDownload = {
  url: string
  shouldDownload?: boolean
  securityCode?: string | undefined
}

export async function handleGenericDocumentDownload({
  url,
  shouldDownload,
  securityCode,
}: GenericDocumentDownload) {
  const headers = await getXSecurityCodeOrAuthorizationHeaders(securityCode)

  if (!headers) {
    toast({ title: 'Falha na autenticação' })
    return
  }

  const response = await fetch(url, {
    headers,
  })

  const xml: string | undefined = await new Promise((resolve, reject) => {
    if (response.status >= 200 && response.status < 300) {
      response
        .blob()
        .then((blob) => {
          if (shouldDownload) {
            const contentDispositionHeader = response.headers.get(
              'Content-Disposition',
            )

            console.log({
              contentDispositionHeader,
              response,
              headers: response.headers.values(),
            })
            const defaultFileName = 'documento.xml'
            const fileName = contentDispositionHeader
              ? contentDispositionHeader.split('filename=')[1] ||
                defaultFileName
              : defaultFileName

            const a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.setAttribute('download', fileName)
            a.click()
          }

          const reader = new FileReader()
          reader.onload = () => {
            const readerResult = reader.result // The result is the Blob data as a string

            if (typeof readerResult === 'string') {
              resolve(readerResult)
            } else {
              resolve(undefined)
            }
          }
          reader.readAsText(blob)
        })
        .catch((error) => {
          console.log({
            handleDocumentAcademicDocumentationsBulkZipDownloadError: error,
          })
          // Handle error
          resolve(undefined)
        })
    } else {
      toast({ title: 'Não foi possível realizar o download' })
      resolve(undefined)
    }
  })

  return xml
}

export const useGenericDocumentDownload = () => {
  const [isDownloading, setIsDownloading] = useState(false)

  async function downloadGenericDocument(props: GenericDocumentDownload) {
    setIsDownloading(true)
    const res = await handleGenericDocumentDownload(props)
    setIsDownloading(false)
    return res
  }

  return {
    downloadGenericDocument,
    isDownloading,
  }
}
